module.exports = __webpack_public_path__ + "media/St 4-Question 13-hint.9f8c1991.wav";